export default __webpack_public_path__ + "static/Dashboard-5@2x-b89913690c9406ced17fb0513017a241.svg";